import * as actions from '../driversActions';

const initialState = {
  vehicles: [],
  drivers: [],
  driversHasVehicles: [],

  loadingVehicles: false,
  loadingDrivers: false,
};

const updateDrivers = (state, payload) => {
  state = Object.assign({}, state, {
    drivers: payload.drivers,
    driversHasVehicles: payload.driversHasVehicles,
    loadingDrivers: false,
  });

  return state;
};

const updateVehicles = (state, payload) => {
  state = Object.assign({}, state, {
    vehicles: payload,
    loadingVehicles: false,
  });

  return state;
};

const updateDriversAndVehicles = (state, payload) => {
  state = Object.assign({}, state, {
    vehicles: payload.vehicles,
    drivers: payload.drivers,
    driversHasVehicles: payload.driversHasVehicles,

    loadingVehicles: false,
    loadingDrivers: false,
  });

  return state;
};

const updateLoadingStart = (state, payload) => {
  state = Object.assign({}, state, {});

  if (payload.includes('vehicles')) {
    state.loadingVehicles = true;
  }
  if (payload.includes('drivers')) {
    state.loadingDrivers = true;
  }

  return state;
};

const clearData = (state) => {
  state = { ...state, ...initialState };
  return state;
};

export default (state = initialState, { type, payload = null }) => {
  switch (type) {
    case actions.UPDATE_DRIVERS:
      return updateDrivers(state, payload);
    case actions.UPDATE_VEHICLES:
      return updateVehicles(state, payload);
    case actions.UPDATE_DRIVER_AND_VEHICLES:
      return updateDriversAndVehicles(state, payload);

    case actions.UPDATE_LOADING_START:
      return updateLoadingStart(state, payload);

    case actions.CLEAR_DATA:
      return clearData(state);
  }
  return state;
};
